<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="ORIM-Book-Title">The Glass-Sided Ants’ Nest</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dickinson_TheGlassSidedAntsNest_3P_MD.vue?18ec5bd8